/* eslint-disable */


export enum AppRoute {

  WelcomePage = '/welcome/:customerId?/:tcid?',
  IdentityTab = '/identity',
  Submisson = '/submission/:customerId?/:tcid?',
  OTPAuthentication = '/authentication/:customerId?/:tcid?',
  ResidenceTab = '/residence/:customerId?/:tcid?',
  IncomeTab = '/income',
  IDValidation = '/idvalidator',
  SelfieUpload = '/selfieupload',
  LivelinessCheckFailed = '/livelinesscheck/failed'

}
